import React from 'react';
import config from '../config';
import SectionReveal from '../components/SectionReveal';
import './Terms.css';

function Terms() {
  const tc = config.termsAndConditions;

  return (
    <main className="terms-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero__content">
            <span className="section-badge">Policies</span>
            <h1>Terms & Conditions</h1>
            <p>{tc.title}</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="terms-content">
            {tc.sections.map((section, idx) => (
              <SectionReveal key={idx} delay={idx * 0.1}>
                <div className="terms-card">
                  <div className="terms-card__number">{idx + 1}</div>
                  <h3>{section.heading}</h3>
                  <p>{section.content}</p>
                </div>
              </SectionReveal>
            ))}

            <SectionReveal delay={0.4}>
              <div className="terms-support">
                <h3>Support & Feedback</h3>
                <p>{tc.supportNote}</p>
                <a href={`mailto:${tc.supportEmail}`} className="btn btn-primary">
                  📩 {tc.supportEmail}
                </a>
              </div>
            </SectionReveal>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Terms;
